import { Validator } from '@vista-digital/validator';
/**
 * Size options for the Google reCAPTCHA V2 component.
 */
export var GoogleRecaptchaV2Size;
(function (GoogleRecaptchaV2Size) {
    /**
     * Render the Google reCAPTCHA V2 component as a normal-sized checkbox (default).
     */
    GoogleRecaptchaV2Size["Normal"] = "normal";
    /**
     * Render the Google reCAPTCHA V2 component as a compact-sized checkbox.
     */
    GoogleRecaptchaV2Size["Compact"] = "compact";
    /**
     * Hide the Google reCAPTCHA V2 component unless a manual challenge is necessary.
     */
    GoogleRecaptchaV2Size["Invisible"] = "invisible";
})(GoogleRecaptchaV2Size || (GoogleRecaptchaV2Size = {}));
export const googleRecaptchaV2SizeValidator = Validator.oneOf(Object.values(GoogleRecaptchaV2Size));
//# sourceMappingURL=size.js.map